import React from 'react';
import styled from 'styled-components';

export const SocialLoginIcon = ({ logo, ...props}) => (
  <StyledButton {...props}>
    <ButtonLogo src={logo}/>
  </StyledButton>
);

const StyledButton = styled.button`
  width: 3.125rem;
  height: 3.125rem;
  padding: 0.75rem;
  border-radius: 100%;
  border: none;
  cursor: pointer;
`;

const ButtonLogo = styled.img`
  width: 1.5rem;
  height: 1.5rem;
`